import {inject, customElement, bindable, bindingMode} from 'aurelia-framework';
import {AuthService} from '../../../services/auth-service';
import {ContentService} from '../../../services/content-service';
import {User, UserDetails} from '../../../services/user-service';
import {CurrentGroup} from '../../../services/group/current-group';
import {SmDeviceDetected} from '../../../tools/sm-device-detected';

@inject(AuthService, ContentService, UserDetails, CurrentGroup, SmDeviceDetected)
@customElement('user-menu')
export class UserMenu {

  userData: Partial<User>;
  displayUserMenu: boolean;

  @bindable({
    defaultBindingMode: bindingMode.twoWay
  }) visible;

  constructor(private __authService: AuthService, private __contentService: ContentService, userDetails: UserDetails, private __currentGroup: CurrentGroup, private device: SmDeviceDetected) {
    this.userData = userDetails.data;
  }

  openMenu(event) {
    let element = (event.target && event.target.tagName != 'DIV') ? event.target.parentElement : event.target;
    switch (element.id) {
    case 'userMenu':
      this.displayUserMenu = !this.displayUserMenu;
      break;
    }
    // @ts-ignore
    console.log(this.breakpoints);
  }

  logOut() {
    this.__authService.logOut();
  }

  usrProfile() {
    this.__contentService.showUser(this.userData.nickname, this.__currentGroup.state.groupId);
    this.close();
  }

  close() {
    this.visible = !this.visible;
  }

}

